import { SupportedLanguageCode } from "@/utils/language-util";

type PolicyLinkMap = Record<SupportedLanguageCode, string>;

/**
 * 서비스 이용약관 페이지 URL (언어별)
 */
export const TERMS_OF_SERVICE_URL: PolicyLinkMap = {
  ko: "https://salphadtx.notion.site/29289d5f2154802992e5c31358978877",
  en: "https://salphadtx.notion.site/sat-001-terms-of-service",
  ja: "https://salphadtx.notion.site/Terms-of-service-29289d5f215480849d02e83f47456ec3",
};

/**
 * 개인정보 처리방침 페이지 URL (언어별)
 */
export const PRIVACY_POLICY_URL: PolicyLinkMap = {
  ko: "https://salphadtx.notion.site/29289d5f2154806aa013d459a6205852",
  en: "https://salphadtx.notion.site/sat-001-privacy",
  ja: "https://salphadtx.notion.site/Privacy-29289d5f2154800c861dc6c475304dc3",
};

/**
 * 사이버보안 관련 안내 사항 페이지 URL (언어별)
 */
export const CYBERSECURITY_URL: PolicyLinkMap = {
  ko: "https://salphadtx.notion.site/29289d5f21548057ac0fe083bbd82aed",
  en: "https://salphadtx.notion.site/cybersecurity-incident-notification",
  ja: "https://salphadtx.notion.site/Cybersecurity-Incident-Notification-29289d5f215480eabee4e2c32a81c9e9",
};
